import {YMaps} from "@iminside/react-yandex-maps";
import {YANDEX_MAPS_API_KEY} from "../model/constants";
import {YandexMapsProviderProps} from "../model/types";

export const YandexMapsProvider = (
    {
        query,
        children,
        ...props
    }: YandexMapsProviderProps
) => {
    return (
        <YMaps
            query={{
                lang: "ru_RU",
                apikey: YANDEX_MAPS_API_KEY,
                ...query
            }}
            {...props}
        >
            {children}
        </YMaps>
    );
};
